export default __webpack_public_path__ + "handshake.svg?fa4716a097e5bd1ca4868a29ba506385";